import React, { useState, useRef } from "react";
import "./home.css";
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header1 from "./header1";

{/* Diwakkar Kumar */}

const Desktop4 = () => {
  const videoRef = useRef(null);

  const handleVideoClick = () => {
    const video = videoRef.current;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  const handleVideoDoubleClick = () => {
    const video = videoRef.current;

    if (video.requestFullscreen) {
      video.requestFullscreen();
    } else if (video.mozRequestFullScreen) {
      video.mozRequestFullScreen();
    } else if (video.webkitRequestFullscreen) {
      video.webkitRequestFullscreen();
    } else if (video.msRequestFullscreen) {
      video.msRequestFullscreen();
    }
  };

  return (

    <div className="html" >
      
      {/* Diwakkar Kumar */}
      <video className="myvideo" autoPlay
          loop
          muted
          onClick={handleVideoClick}
          onDoubleClick={handleVideoDoubleClick} id="myVideo">
  <source src="webs.mp4" type="video/mp4"/>
</video>


      <div
        className="desktop-4m"
      >
        
       <a href="/">
       <img className="image-iconm" alt="" src="/logo.png" />
        <p className='titlename4'>VREON TECH INDIA PVT LTD</p>
       </a>
        <div className="about-parent4m">
          <b className="aboutm">

            <Link className="menu" to="/about">ABOUT</Link>

          </b>
          <b className="servicem">
            <Link className="menu" to="/service">SERVICES</Link>
          </b>
          <b className="portfoliom">

            <Link className="menu" to="/portfolio">PORTFOLIO</Link>

          </b>
          <b className="ourproducts1m">
            <Link className="menu" to="/products">PRODUCTS</Link>
          </b>

          <b className="contactm">
            <p className="contactm1">
              <Link className="menu" to="/contact">CONTACT</Link>
            </p>
          </b>

          {/* Show this section only on mobile devices */}
          <div className="transform-your-vision mobile-only">
            <div className="frame-childm1">
              <b className="homem1">

                <Link to="/" className="linkk" >HOME</Link>

              </b>



            </div>

          </div>
          <div className="frame-childm" />
          <b className="homem">

            <Link to="/">HOME</Link>

          </b>

        </div>
        
        
        <div className="step-into-the-future-of-busine-wrapper text-center">
        
          <div className="step-into-the-containerm">
            
            <p className="step-into-them">
              Step into the future of business innovation. Our cutting- edge
              Extended Reality (VR/AR) solutions empower you to differentiate your
              brand and engage, educate, and inspire your audiences like never
              before.
            </p>
          </div>
          
          <video
          ref={videoRef}
          className="video"
          autoPlay
          loop
          muted
          onClick={handleVideoClick}
          onDoubleClick={handleVideoDoubleClick}
        >
          <source src="/Video.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        </div>
        

        {/* Transform Your Vision Section */}

        <div className="transform-your-vision text-center">
        <b className="transformyourvi">TRANSFORM YOUR VISION INTO REALITY</b>
        </div>
      </div>
      
      <div className="footer">
        <Footer />
      </div>
      
    </div>
  );
};

export default Desktop4;
